import {
    createContext,
    useContext
} from "react";
import type {
    ComposerContextType
} from "./type";

export const ComposerContext = createContext<ComposerContextType | null>(null);

export const useComposerContext = (): ComposerContextType | null => {
    return useContext(ComposerContext);
};
